<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="($t('tasks'))"
      icon="mdi-checkbox-marked-circle-outline"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      @refresh="getItems"
      @print="printStudio = true"
      @filter="filter = true"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #tools>
      <export-excel
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      <v-menu offset-y left>
        <template v-slot:activator="{ attrs, on }">
          <button type="button" class="pl-btn pl-btn--icon" v-bind="attrs" v-on="on">
            <v-icon size="16">mdi-dots-vertical</v-icon>
          </button>
        </template>
        <v-list dense>
          <log
            v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
            ref="logRef"
            :type-prop="typeForm"
            :listProp="true"
            mode-prop="button"
          />
          
          
        </v-list>
      </v-menu>
      </template>
      <template #bulk>
      <button
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
      </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-column-resize="taskListColumnPlugins"
        v-column-drag="taskListColumnPlugins"
        v-column-pin="taskListColumnPlugins"
        :height="mobileShow ? 323 : plTableH"
        :show-select="showSelect"
        fixed-header
        v-model="selected"
        :headers="tableHeaders"
        :items="items"
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :loading="false"
        multi-sort
        dense
        item-key="text"
        :footer-props="plFooterProps"
      >
        <template v-slot:item.actions="{ item }">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                link
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                link
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-eye-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('show')" />
              </v-list-item>
              <v-list-item @click="$refs.logRef.openDialog(item.id, type, null)">
                <v-list-item-icon>
                  <v-icon>mdi-history</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('history')" />
              </v-list-item>
              <v-list-item
                link
                @click="opemDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.title="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                :color="((item && item.last_status && item.last_status.status) ? item.last_status.status.color : 'primary')"
                text
                v-on="on"
                @click="edit(item)"
              >
                {{ item.title }}
              </v-btn>
            </template>
            <span>{{ $t('edit') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.id="{ item }">
          {{ parseInt(items.indexOf(item))+ parseInt(from) }}
        </template>
        <template v-slot:item.relation="{ item }">
          <div
            v-if="item.relation"
            class="pt-1"
          >
            <v-chip
              label
              color="grey"
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text">
                {{ item.relation.name }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.tags="{ item }">
          <pl-tags :tags="item.tags || []" />
        </template>
        <template v-slot:item.participants="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(party, index) in item.participants"
              :key="index"
              :color="party?.user?.color"
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
            >
              <v-avatar
                v-if="party && party.user && party.user.avatar"
                left
                style="margin: 1px"
              >
                <v-img :src="party?.user?.avatar?.link" />
              </v-avatar>
              <span class="px-1 white--text">
                {{ party?.user?.name }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.last_status.status_id="{ item }">
          <v-chip
            v-if="item && item.last_status && item.last_status.status"
            :color="item.last_status.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1 mb-1"
            @click="edit(item)"
          >
            <span class="px-2 white--text">
              {{ item.last_status.status.name }}
            </span>
          </v-chip>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="($t('tasks'))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="true"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @filter="filter = true"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t('tasks'))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />

        <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      max-width="960"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ $t("taskListFilterTitle") }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">
          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-account-outline</v-icon>
              {{ $t("taskFilterParties") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="participants"
                title="participants"
                type="partners"
                :filter="true"
                :multiple="true"
              />
              <v-select
                v-model="typeMethod"
                :label="$t('relation-whit')"
                :items="typeItems"
                dense
                outlined
                hide-details
                item-value="value"
                item-text="text"
              />
              <autocomplete
                ref="refRelation"
                v-model="relation"
                :title="(typeMethod == 'account' ? 'customer' : 'invoice')"
                :type="(typeMethod == 'account' ? 'person' : 'invoices')"
              />
              <status
                v-model="sellStatus"
                :hideconfig="true"
                :multiple="true"
              />
              <tag v-model="tag" />
              <autocomplete
                v-model="functor"
                title="functor"
                type="partners"
                :multiple="false"
                :filter="true"
              />
              <autocomplete
                v-model="registerar"
                title="registerar"
                type="partners"
                :filter="true"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-calendar-range</v-icon>
              {{ $t("accFilterDateTime") }}
            </div>
            <div class="acf-grid acf-grid--4">
              <div>
                <v-text-field
                  id="fromId"
                  v-model="fromDate"
                  :label="$t('from') + ' ' + $t('createDate')"
                  prepend-inner-icon="mdi-calendar-start"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="fromDate"
                  element="fromId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toId"
                  v-model="toDate"
                  :label="$t('until') + ' ' + $t('createDate')"
                  prepend-inner-icon="mdi-calendar-end"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="toDate"
                  element="toId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  :min="fromDate"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="fromIdUpdate"
                  v-model="fromDateUpdate"
                  :label="$t('from') + ' ' + $t('dateUpdate')"
                  prepend-inner-icon="mdi-calendar-start"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="fromDateUpdate"
                  element="fromIdUpdate"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toIdUpdate"
                  v-model="toDateUpdate"
                  :label="$t('until') + ' ' + $t('dateUpdate')"
                  prepend-inner-icon="mdi-calendar-end"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="toDateUpdate"
                  element="toIdUpdate"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  :min="fromDate"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="fromIdDue"
                  v-model="fromDueDate"
                  :label="$t('from') + ' ' + $t('dueDate')"
                  prepend-inner-icon="mdi-calendar-start"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="fromDueDate"
                  element="fromIdDue"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toIdDue"
                  v-model="toDueDate"
                  :label="$t('until') + ' ' + $t('dueDate')"
                  prepend-inner-icon="mdi-calendar-end"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="toDueDate"
                  element="toIdDue"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  :min="fromDate"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
            </div>
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon large>
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-task') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
    />
  </div>
</template>

<script>
  import Task from '../task/task'
  import autocomplete from '../../components/general/patial/autocomplete'
  import General from '@/Mixins/general'
  import {
    applyColumnSettings,
    loadColumnSettings,
  } from '@/plugins/columnSettings/columnSettings'
  import { reorderPinnedHeaders } from '@/plugins/columnPin/columnPin'
  import ProList from "@/Mixins/proList";
  import ProListFrame from "@/components/proList/ProListFrame.vue";
  import ProListMobile from "@/components/proList/ProListMobile.vue";
  import PrintStudio from "@/modules/print/PrintStudio.vue";
  export default {
    name: 'TaskList',
    components: {
      ProListFrame,
      ProListMobile,
      PrintStudio,
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      autocomplete,
      Task,
    },
    mixins: [General, ProList],
    props: ['input', 'type', 'refId', 'typeProp', 'accountProp', 'mobileShow'],
    data: () => ({
      selected: [],
      excelItems: [],
      deletDialog: false,
      filter: false,
      pageCount: 1,
      model: null,
      from: 1,
      relation: null,
      participants: null,
      typeMethod: null,
      typeItems: null,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 10,
      },
      // Table pagination options. Kept separate from `options` because the
      // General mixin reuses `options` for money formatting and overwrites it
      // (beforeMount / currency watcher), which dropped page/itemsPerPage.
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      typeForm: 'task',
      headers: null,
      listViewportObserver: null,
      listViewportRaf: null,
      search: null,
      taskStatus: null,
      tag: null,
      functor: null,
      fromDate: null,
      toDate: null,
      registerar: null,
      fromDateUpdate: null,
      toDateUpdate: null,
      fromDueDate: null,
      toDueDate: null,

    }),
    computed: {

      activeFilterChips () {
        var app = this
        var has = function (v) {
          if (Array.isArray(v)) return v.length > 0
          return v !== null && v !== undefined && v !== '' && v !== '0' && v !== 0
        }
        var show = function (v) {
          if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0])
          if (v && typeof v === 'object') return v.name || v.text || v.label || ''
          return typeof v === 'number' || typeof v === 'string' ? String(v) : ''
        }
        var pick = function (items, v, key) {
          var arr = Array.isArray(v) ? v : [v]
          return arr
            .map(function (x) {
              var f = (items || []).find(function (i) { return i.value === x })
              return f ? f[key || 'text'] : ''
            })
            .filter(Boolean)
            .join('، ')
        }
        var defs = [
          ['participants', app.$t('participants')],
          ['typeMethod', app.$t('relation-whit'), pick(app.typeItems, app.typeMethod)],
          ['relation', app.typeMethod == 'account' ? app.$t('customer') : app.$t('invoice')],
          ['sellStatus', app.$t('status')],
          ['tag', app.$t('tag')],
          ['functor', app.$t('functor')],
          ['registerar', app.$t('registerar')],
          ['fromDate', app.$t('from') + ' ' + app.$t('createDate')],
          ['toDate', app.$t('until') + ' ' + app.$t('createDate')],
          ['fromDateUpdate', app.$t('from') + ' ' + app.$t('dateUpdate')],
          ['toDateUpdate', app.$t('until') + ' ' + app.$t('dateUpdate')],
          ['fromDueDate', app.$t('from') + ' ' + app.$t('dueDate')],
          ['toDueDate', app.$t('until') + ' ' + app.$t('dueDate')],
        ]
        return defs
          .filter(function (d) { return has(app[d[0]]) })
          .map(function (d) {
            return { key: d[0], label: d[1], value: d.length > 2 ? d[2] : show(app[d[0]]) }
          })
      },
      proListKey () {
        return this.taskListColumnPersistKey
      },
      proListLocked () {
        return this.taskListLockedColumns
      },
      showSelect () {
        if(!this.isMobile) {
          return true
        } else {
          return false
        }
      },
      isDesktopListViewport () {
        return !this.isMobile && !this.mobileShow
      },
      taskListColumnPersistKey () {
        return 'task-list-columns-' + (this.$route.name || 'TaskList')
      },
      taskListLockedColumns () {
        // Fixed sticky block: select + actions + id (no unpin/drag)
        var locked = ['actions', 'id']
        return this.showSelect ? ['__select'].concat(locked) : locked
      },
      taskListColumnPlugins () {
        // show-select inserts a leading checkbox <th>; pad visibleHeaders so
        // pin/resize/drag index mapping stays aligned with thead cells.
        var selectHeader = {
          value: '__select',
          text: '',
          width: 32,
          sortable: false,
          pinned: false,
          originalIndex: -1,
        }
        var visible = this.showSelect
          ? [selectHeader].concat(this.tableHeaders || [])
        : this.tableHeaders || []
        return {
          headers: this.headers,
          visibleHeaders: visible,
          locked: this.taskListLockedColumns,
          anchor: 'id',
          minWidth: 60,
          persistKey: this.taskListColumnPersistKey,
        }
      }
    },
    watch: {
      typeProp (val) {
        if (val === 'participants' && this.accountProp) {
          this.participants = [this.accountProp.id]
        }
        if (val === 'related' && this.accountProp) {
          this.typeRelation = 'account'
          this.relation = this.accountProp.id
        }
      },
      accountProp (val) {
        if (val === 'participants' && this.accountProp) {
          this.participants = [this.accountProp.id]
        }
        if (val === 'related' && this.accountProp) {
          this.typeMethod = 'account'
          this.relation = this.accountProp.id
        }
        this.getItems()
      },
      typeMethod () {
        if (!this.loading) {
          this.relation = null
          this.$refs.refRelation.clear()
          if (this.typeMethod) {
            this.$refs.refRelation.initList = false
            this.$refs.refRelation.getItems({ query: null, page: 1 })
          }
        }
      },
      participants (val) {
      },
      taskDialog () {
        if (!this.taskDialog) {
          this.getItems()
        }
      },
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        this.model = this.selected[0].text
        this.temp = this.selected[0].text
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      tableOptions: {
        handler () {
          var app = this
          app.sortBy = []
          app.tableOptions?.sortBy?.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      loading (val) {
        if (!val && this.isDesktopListViewport) {
          this.$nextTick(() => {
            this.bindListViewportObserver()
            this.scheduleDesktopTableHeightUpdate()
          })
        }
      },
      isDesktopListViewport (val) {
        if (val) {
          this.$nextTick(() => {
            this.updateDesktopTableHeight()
            this.bindListViewportObserver()
          })
        } else {
          this.unbindListViewportObserver()
          this.tableHeight = window.innerHeight - 245
        }
      },
    },
    beforeMount () {
      this.typeItems = [
        {
          value: 'invoice',
          text: this.$t('invoice'),
        },
        {
          value: 'account',
          text: this.$t('customer'),
        },
      ]
    },
    mounted () {
      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 20,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'id',
          width: 20,
        },
        {
          text: this.$t('title'),
          sortable: true,
          value: 'title',
          table: 'crm_task.title',
        },
        {
          text: this.$t('participants'),
          sortable: false,
          value: 'participants',
        },
        {
          text: this.$t('relation-whit'),
          sortable: false,
          value: 'relation',
        },
        {
          text: this.$t('status'),
          sortable: false,
          value: 'last_status.status_id',
        },
        {
          text: this.$t('tag'),
          sortable: true,
          value: 'tags',
        },
        {
          text: this.$t('registerar'),
          sortable: false,
          value: 'user.name',
        },
      ]
      reorderPinnedHeaders(this.headers, {
        locked: this.taskListLockedColumns,
        anchor: 'id',
      })
      this.loadTaskListColumnSettings()
      if (this.input) {
        this.model = this.input
      }
      if (this.typeProp === 'participants' && this.accountProp) {
        this.participants = [this.accountProp.id]
      }
      if (this.typeProp === 'related' && this.accountProp) {
        this.typeRelation = 'account'
        this.relation = this.accountProp.id
      }
      this.getItems()
      if (this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver()
          this.updateDesktopTableHeight()
          this.$nextTick(() => {
            this.bindListViewportObserver()
            this.scheduleDesktopTableHeightUpdate()
          })
        })
      }
    },
    activated () {
      this.getItems()
      if (this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver()
          this.scheduleDesktopTableHeightUpdate()
        })
      }
    },
    deactivated () {
      this.unbindListViewportObserver()
    },
    beforeDestroy () {
      this.unbindListViewportObserver()
      if (this.listViewportRaf) {
        cancelAnimationFrame(this.listViewportRaf)
        this.listViewportRaf = null
      }
    },
    methods: {

      resetFilters () {
        var app = this
        ;[
          'participants', 'typeMethod', 'relation', 'sellStatus', 'tag', 'functor', 'registerar',
          'fromDate', 'toDate', 'fromDateUpdate', 'toDateUpdate', 'fromDueDate', 'toDueDate',
        ].forEach(function (k) { app[k] = null })
      },
      resolveRefEl (ref) {
        if (!ref) return null
        return ref.$el || ref
      },
      onResize () {
        if (this.isDesktopListViewport) {
          this.updateDesktopTableHeight()
          return
        }
        this.tableHeight = window.innerHeight - 245
      },
      scheduleDesktopTableHeightUpdate () {
        if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf)
        this.listViewportRaf = requestAnimationFrame(() => {
          this.listViewportRaf = null
          this.updateDesktopTableHeight()
        })
      },
      updateDesktopTableHeight () {
        if (!this.isDesktopListViewport) {
          this.tableHeight = window.innerHeight - 245
          return
        }
        const rootEl = this.resolveRefEl(this.$refs.listRoot)
        const toolbarEl = this.resolveRefEl(this.$refs.listToolbar)
        const summaryEl = this.resolveRefEl(this.$refs.listSummary)
        const tableColEl = this.resolveRefEl(this.$refs.listTableCol)
        const tableEl = this.resolveRefEl(this.$refs.listTable)
        if (!rootEl || !tableColEl) {
          this.tableHeight = window.innerHeight - 245
          return
        }
        const rootStyle = window.getComputedStyle(rootEl)
        const rootPadding =
          (parseFloat(rootStyle.paddingTop) || 0) +
          (parseFloat(rootStyle.paddingBottom) || 0)
        const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0
        let summaryHeight = 0
        if (summaryEl) {
          const summaryVisible =
            summaryEl.offsetParent !== null ||
            summaryEl.getClientRects().length > 0
          if (summaryVisible) {
            const summaryStyle = window.getComputedStyle(summaryEl)
            summaryHeight =
              summaryEl.offsetHeight +
              (parseFloat(summaryStyle.marginTop) || 0) +
              (parseFloat(summaryStyle.marginBottom) || 0)
          }
        }
        const colStyle = window.getComputedStyle(tableColEl)
        const colPadding =
          (parseFloat(colStyle.paddingTop) || 0) +
          (parseFloat(colStyle.paddingBottom) || 0)
        const footerEl = tableEl
          ? tableEl.querySelector('.v-data-footer')
          : null
        const footerHeight = footerEl ? footerEl.offsetHeight : 0
        const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null
        const tableMargins = tableStyle
          ? (parseFloat(tableStyle.marginTop) || 0) +
            (parseFloat(tableStyle.marginBottom) || 0)
          : 0
        const available =
          rootEl.clientHeight -
          rootPadding -
          toolbarHeight -
          summaryHeight -
          colPadding -
          footerHeight -
          tableMargins -
          3
        this.tableHeight = Math.max(180, Math.floor(available))
      },
      bindListViewportObserver () {
        if (typeof ResizeObserver === 'undefined') return
        this.unbindListViewportObserver()
        const rootEl = this.resolveRefEl(this.$refs.listRoot)
        const summaryEl = this.resolveRefEl(this.$refs.listSummary)
        const tableColEl = this.resolveRefEl(this.$refs.listTableCol)
        const tableEl = this.resolveRefEl(this.$refs.listTable)
        const footerEl = tableEl ? tableEl.querySelector('.v-data-footer') : null
        if (!rootEl && !summaryEl && !tableColEl) return
        this.listViewportObserver = new ResizeObserver(() => {
          this.scheduleDesktopTableHeightUpdate()
        })
        if (rootEl) this.listViewportObserver.observe(rootEl)
        if (summaryEl) this.listViewportObserver.observe(summaryEl)
        if (tableColEl) this.listViewportObserver.observe(tableColEl)
        if (footerEl) this.listViewportObserver.observe(footerEl)
      },
      unbindListViewportObserver () {
        if (this.listViewportObserver) {
          this.listViewportObserver.disconnect()
          this.listViewportObserver = null
        }
      },
      loadTaskListColumnSettings () {
        var app = this
        if (!app.headers || !app.headers.length) return
        loadColumnSettings(app, app.taskListColumnPersistKey).then(function (snapshot) {
          if (!snapshot || !snapshot.length) return
          applyColumnSettings(app.headers, snapshot, {
            locked: app.taskListLockedColumns,
            anchor: 'id',
          })
          app.$forceUpdate()
        })
      },
      opemDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'taskEdit', params: { id: item.id } })
      },
      getItems () {
        var app = this
        app.filter = false
        app.loading = true
        app.$axios.get(this.$endpoint + 'task/show', {
          params: {
            search: app.search,
            page: (app.allRows ? app.excelPage : app.tableOptions.page),
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            options: app.tableOptions,
            participants: app.participants,
            typeRelation: app.typeMethod,
            relation: app.relation,
            typeProp: app.typeProp,
            accountProp: (app.accountProp ? app.accountProp.id : null),
            tag: app.tag,
            status: app.sellStatus,
            functor: app.functor,
            fromDate: app.fromDate,
            toDate: app.toDate,
            user_id: app.registerar,
            fromDateUpdate: app.fromDateUpdate,
            toDateUpdate: app.toDateUpdate,
            fromDueDate: app.fromDueDate,
            toDueDate: app.toDueDate
          },
        })
          .then(res => {
            res = res.data
            if (!app.allRows) {
              app.items = res.data
              app.totalItems = res.total
              app.last_page = res.last_page
              app.pageCount = res.last_page
              app.from = res.from
              app.creatExcelData(res.data)
            } else {
              app.generateExcellForAllData(res.data, res.last_page)
            }
          })
          .catch(err => {
            var error = err.response
            if (error.status === 401) {
              this.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'task/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deleteItem = null
            app.getItems()
          })
          .finally(() => (app.loading = false))
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          app.excelItems.push({
            title: String(d.title),
            status: (d.last_status && d.last_status.status ? d.last_status.status.name : ''),
            content: d.content,
            account: (d.relation && d.type === 'account' ? d.relation.name : ''),
            mobile: (d.relation && d.type === 'account' ? d.relation.mobile : ''),
            phone: (d.relation && d.type === 'account' ? d.relation.phone : ''),
          })
        })
      },
    },
  }
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";

::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
} 
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
</style>
